export const ATENDABOT_ORDER_CONTROL_EVENT = 'atendabot-order-control-changed';

export const notifyAtendabotOrderControl = (enabled: boolean) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ATENDABOT_ORDER_CONTROL_EVENT, {
    detail: { enabled },
  }));
};